const DEV_PORT_OFFSET = Number(process.env.GITBOOK_DEV_PORT_OFFSET || 0);

/**
 * Shift a local port by GITBOOK_DEV_PORT_OFFSET, so several local stacks can run side by side.
 */
export function localPort(port: number): number {
    return port + DEV_PORT_OFFSET;
}

/**
 * Shift a service spec's dev port by GITBOOK_DEV_PORT_OFFSET, so its server and every caller
 * reading the spec agree on it.
 */
export function withLocalDevPort<Spec extends { devPort?: number }>(spec: Spec): Spec {
    return spec.devPort === undefined ? spec : { ...spec, devPort: localPort(spec.devPort) };
}
